module.exports = __webpack_public_path__ + "static/media/mycart.21f91f9b.png";